module.exports = __webpack_public_path__ + "palestine.svg?dee1e8ced0f4f8ffd836dc8050dfdaf2";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/countries/svg/palestine.svg
// module id = 261
// module chunks = 10